import { render, staticRenderFns } from "./BsProgress.vue?vue&type=template&id=11642c6f&"
import script from "./BsProgress.vue?vue&type=script&lang=js&"
export * from "./BsProgress.vue?vue&type=script&lang=js&"
import style0 from "./BsProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports